import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLenis, scrollToId } from "../lib/smooth";

/**
 * On route changes:
 * - If URL has a hash (e.g. /#nosotros), momentum-scroll to that element via Lenis
 * - Otherwise scroll to top instantly
 *
 * Place inside <BrowserRouter> tree.
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const tryScroll = (attempt = 0) => {
        if (!scrollToId(id) && attempt < 10) {
          setTimeout(() => tryScroll(attempt + 1), 100);
        }
      };
      tryScroll();
    } else {
      const lenis = getLenis();
      if (lenis) lenis.scrollTo(0, { immediate: true });
      else window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);

  return null;
}
